import { ComboBox } from 'src/components/credit/ui/comboBox/ComboBox';
import { IError } from '../BusinessInfo';
import Input from 'src/components/forms/input';
import React from 'react';
import { useCreditForm } from 'src/customHooks/useCreditForm';
import { useLocalization } from 'src/utils/useLocalization';
import { getTitleOptions, validateMI, validateOwnership } from '../../utils';

interface IProps {
    handlerEdit: Function;
    object: {
        firstName: string;
        mi: string;
        lastName: string;
        title: string;
        ownership: string;
    };
    errors: {
        firstName: IError;
        mi: IError;
        lastName: IError;
        title: IError;
        ownership: IError;
    };
    disabled: boolean;
}

const OwnerComponent = ({ handlerEdit, object, errors, disabled }: IProps) => {
    const { businessComercial } = useLocalization();
    const { markCreditFormTouched } = useCreditForm();
    const propertyName = 'owner';
    const titleOptions = getTitleOptions(businessComercial);
    return (
        <div className={'business-owner u-mt-large'}>
            <span className='c-form-section__header-content'>
                <span className='c-form-section__title  js-form-section__trigger'>
                    <span
                        className='c-form-section__title-text form-section__title-font'
                        role='heading'
                    >
                        {businessComercial.OWNERS_TITLE}
                    </span>
                </span>
            </span>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/3 u-1/1@xs'>
                        <Input
                            labelName={businessComercial.OWNERS_NAME}
                            type={'text'}
                            name={'firstName'}
                            handlerChange={(e: any) => {
                                handlerEdit(e.target, propertyName);
                            }}
                            value={object.firstName}
                            maxlength={20}
                            asTouched={errors.firstName.error}
                            asErrors={errors.firstName.msg}
                        />
                    </div>
                    <div className='o-layout__item  u-1/3 u-1/1@xs'>
                        <Input
                            labelName={businessComercial.OWNERS_MI}
                            type={'text'}
                            name={'mi'}
                            handlerChange={(e: any) => {
                                markCreditFormTouched();
                                const { value } = e.target;
                                if (validateMI(value) || value === '')
                                    handlerEdit(e.target, propertyName);
                            }}
                            value={object.mi}
                            maxlength={1}
                            asTouched={errors.mi.error}
                            asErrors={errors.mi.msg}
                        />
                    </div>
                    <div className='o-layout__item  u-1/3  u-1/1@xs'>
                        <Input
                            labelName={businessComercial.OWNERS_LASTNAME}
                            type={'text'}
                            name={'lastName'}
                            handlerChange={(e: any) => {
                                handlerEdit(e.target, propertyName);
                            }}
                            value={object.lastName}
                            maxlength={20}
                            asTouched={errors.lastName.error}
                            asErrors={errors.lastName.msg}
                        />
                    </div>
                </div>
            </div>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/3 u-1/1@xs'>
                        <div className='c-form-field'>
                            <label
                                htmlFor='m1l7e063'
                                className='c-form-field__label'
                            >
                                {businessComercial.OWNERS_TITLELABEL}
                            </label>
                            <div className='c-form-field__box'>
                                <div className='c-input'>
                                    <ComboBox
                                        name={'optionBusinessProvince'}
                                        options={titleOptions}
                                        defaultValue={object.title}
                                        placeholder={
                                            businessComercial.OWNERS_CHOOSETITLE
                                        }
                                        selectedOption={object.title}
                                        onSelect={(value) => {
                                            handlerEdit(
                                                { name: 'title', value },
                                                propertyName,
                                            );
                                        }}
                                        disabled={disabled}
                                    />
                                    {errors.title.error && errors.title.msg && (
                                        <span className={'c-error-message'}>
                                            {errors.title.msg}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='o-layout__item  u-1/3 u-1/1@xs'>
                        <Input
                            labelName={businessComercial.OWNERS_OWNERSHIP}
                            type={'text'}
                            name={'ownership'}
                            handlerChange={(e: any) => {
                                markCreditFormTouched();
                                const {
                                    target: { value },
                                } = e;
                                if (validateOwnership(value))
                                    handlerEdit(e.target, propertyName);
                            }}
                            value={object.ownership}
                            min={0}
                            max={100}
                            asTouched={errors.ownership.error}
                            asErrors={errors.ownership.msg}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OwnerComponent;
